import { Injectable, OnDestroy } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { globalEnvironment } from '@environments/globalEnvironment';
import { interval, Subject, Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class IntervalService implements OnDestroy {
	private functionEmit = new Subject<any>();
	private worker: Worker;
	private intervalSubscription?: Subscription;

	constructor() {
	}

	ngOnDestroy(): void {
		this.intervalSubscription?.unsubscribe();
	}

	public getInterval(): Subject<any> {

		if (!isNullish(this.worker)) {
			try {
				this.worker.onmessage = () => {
					this.functionEmit.next(null)
				};
				return this.functionEmit
			} catch (e) {
				this.intervalSubscription = interval(globalEnvironment.trackIntervalInSec * 1000).subscribe(() => this.functionEmit.next(null))
			}

		} else {
			// Web Workers are not supported in this environment.
			// You should add a fallback so that your program still executes correctly.
		}
	}

	public init() {
		if (typeof Worker !== 'undefined') {
			// Dateiendung und type: module sind Pflicht: esbuild löst den URL-Ausdruck
			// literal auf und emittiert Worker ausschließlich als ES-Module.
			this.worker = new Worker(new URL('./../webworkers/interval.worker.ts', import.meta.url), { type: 'module' });
			this.worker.postMessage({ initTimer: globalEnvironment.trackIntervalInSec * 1000 });
		} else {
			// Web Workers are not supported in this environment.
			// You should add a fallback so that your program still executes correctly.
		}
	}

}



export interface IntervalMsg {
	isRunning: boolean;
	type: IntervalType;
}

export enum IntervalType {
	ServiceWorker = 1,
	DefaultSearchbar = 2
}